// ─────────────────────────────────────────────────────────────────────────────
// Blast › Holes tab — shared types
// Design source : Figma rHPoiskmYrtff7ZBjMWreI, node 2544:670215
// ─────────────────────────────────────────────────────────────────────────────

/** The five radio views of the Holes tab (`?tab=holes&view=<id>`). */
export type HolesView = 'state' | 'geology' | 'quality' | 'drilling' | 'delivery';

export const HOLES_VIEWS: readonly HolesView[] = ['state', 'geology', 'quality', 'drilling', 'delivery'];

export const DEFAULT_HOLES_VIEW: HolesView = 'state';

/** i18n key of each view label (HOLES_TAB block). */
export const HOLES_VIEW_LABEL_KEYS: Record<HolesView, string> = {
  state:    'HOLES_TAB.VIEW_STATE',
  geology:  'HOLES_TAB.VIEW_GEOLOGY',
  quality:  'HOLES_TAB.VIEW_QUALITY',
  drilling: 'HOLES_TAB.VIEW_DRILLING',
  delivery: 'HOLES_TAB.VIEW_DELIVERY',
};

/** Views that render the left "Holes legend" column. Drilling and delivery only have map + table. */
export const HOLES_VIEWS_WITH_LEGEND: ReadonlySet<HolesView> = new Set<HolesView>(['state', 'geology', 'quality']);

export function isHolesView(value: string | null | undefined): value is HolesView {
  return !!value && (HOLES_VIEWS as readonly string[]).includes(value);
}

/** Map display mode: 2D OpenLayers top view or the three.js 3D viewer. */
export type HolesMapMode = 'top' | '3d';
